<div class="mb-1">
  <span class="form-label">Location</span>
  <era-location-select [location]="location()"
                       (locationChange)="locationUpdated($event)"
                       [isEnabled]="isLocationEnabled()"></era-location-select>
</div>
<div class="form-check"
     [hidden]="isHousekeeping() || isStaff() || isFrontDesk() || isBar() || isKiosk()">
  <input id="spare"
         type="checkbox"
         class="form-check-input"
         [formControl]="spareControl"
         [attr.disabled]="isSpare() !== undefined ? true : null" />
  <label class="form-check-label"
         for="spare">Spare</label>
</div>
@if (spareControl.value === false) {
  <div [hidden]="isHousekeeping() || isStaff() || isFrontDesk() || isBar() || isKiosk()">
    <span class="form-label">Room</span>
    <era-room-select [location]="location()"
                     (roomChange)="roomUpdated($event)"> </era-room-select>
  </div>
}